import Popup from '../../utils/popup';

class Termin {
    constructor() {
        this.terminSetting = {
            wybranyMiesiac: null,
            wybranyRok: null,
            liczbaDniWMiesiacu: null,
            kategoriaWydarzen: null,
            kategorieWydarzen: null,
            dataOd: null,
            dataDo: null,
            jezykStrony: 'pl',
            klasyDni: []
        };
    }

    init() {
        const that = this;


        that.setSiteLang();
        //that.getCategories();
        that.setInitialMonth();
        setTimeout(function () {
            that.writeDaysOfTheMonth();
            that.events();
        }, 200);

        //that.setMonthFromSession();
    }

    setSiteLang() {
        const that = this;
        //let langSymbol = $(".fr-lang-switch.d-none").html();
        let langSymbol = $('html').attr('lang');
        if (langSymbol) {
            langSymbol = langSymbol.toLowerCase();
            if ($.inArray(langSymbol, ['pl', 'en']) !== -1) {
                that.terminSetting.jezykStrony = langSymbol;
            }
        }
    }

    translate(textSymbol) {
        const that = this;
        let messages = {
            brak_terminow_w_dniu: {
                pl: 'Brak terminów w wybranym dniu',
                en: 'There are no events on selected date'
            },
            brak_terminow_w_przedziale_dat: {
                pl: 'Brak terminów w wybranym przedziale dat',
                en: 'There are no events on selected date range'
            },
            w_kategorii: {
                pl: 'w kategorii',
                en: 'in category'
            },
            kup_bilet: {
                pl: 'Kup bilet',
                en: 'Buy ticket'
            },
            wszystkie: {
                pl: 'Wszystkie',
                en: 'All'
            },
            spektakl_odwolany: {
                pl: 'Spektakl odwołany',
                en: 'Performance canceled'
            },
            premiera: {
                pl: 'Premiera',
                en: 'Premiere'
            },
            tytul_sezonu: {
                pl: 'Tytuł sezonu',
                en: 'Season title'
            },
            zamkniety: {
                pl: 'Zamknięty',
                en: 'Zamknięty'
            },
            brak_miejsc: {
                pl: 'Brak Miejsc',
                en: 'Sold out'
            },
            termin_niedostepny: {
                pl: 'Termin niedostępny',
                en: 'Unavailable date'
            },
            powiadom: {
                pl: 'Powiadom o dostępności',
                en: 'Send availability notification'
            },
            email_label: {
                pl: 'ADRES E-MAIL',
                en: 'E-MAIL ADDRESS'
            }
        };
        if (messages[textSymbol] && messages[textSymbol][that.terminSetting.jezykStrony]) {
            return messages[textSymbol][that.terminSetting.jezykStrony];
        } else {
            return textSymbol;
        }
    }

    events() {
        const that = this;
        $('.category-list-months li a')
            .off('click')
            .on('click', function() {
                let monthData = $(this).data();
                that.terminSetting.wybranyRok = parseInt(monthData.rok);
                that.terminSetting.wybranyMiesiac = parseInt(monthData.miesiac);
                that.terminSetting.liczbaDniWMiesiacu = parseInt(monthData.dniwmiesiacu);
                $('.category-list-months li').removeClass('selected');
                $(this).parent().addClass('selected');
                let monthDetails = that.getMonthDetails(monthData.rok, monthData.miesiac);
                that.terminSetting.dataOd = monthDetails.startDate;
                that.terminSetting.dataDo = monthDetails.endDate;
                that.writeDaysOfTheMonth();
            });

        $('ul#events-days-list li')
            .off('click')
            .on('click', function() {
                that.getTerms();
            });

        $('ul#events-days-list li a').on('click', function(e) {
            e.preventDefault();
        });

        $('ul#events-category-list li').off('click').on('click', function() {
                $('ul#events-category-list li').removeClass('selected');
                $(this).addClass('selected');
                that.terminSetting.kategoriaWydarzen = $(this).data('category_id');
                that.getTerms();
            });

        // $('ul#events-days-list').mousemove(function(){

        // });
        // $('ul#events-days-list').unbind('mousedown').mousedown(function(){
        //   console.log('mouse down');
        // });

        $('ul#events-days-list')
            .unbind('mouseup')
            .mouseup(function() {
                that.getTerms();
            });

        $('.powiadom-btn')
            .off('click')
            .on('click', function(e) {
                e.preventDefault();
                let termTwonId = $(this).data('id_terminu_twon');
                let termIksorisId = $(this).data('id_terminu_iksoris');

                that.checkUser(termIksorisId);
            });
    }

    checkUser(termIksorisId) {
        const that = this;
        $.ajax({
            url: '/rezerwacja/termin.html',
            method: 'get',
            data: {
                json: true,
                ajax_action: 'pobierz_strone_dostepnosc_info'
            },
            success: function(result) {
                if (result && result.status === 'complete') {
                    let popup = new Popup(
                        '<div class="form__section-header"><strong>' +
                        result.data.stronaBiletyDostepnoscTytul +
                        '</strong></div>' +
                        '<div class="fr-popup__text">' +
                        result.data.stronaBiletyDostepnoscTresc +
                        '</div>' +
                        '<div class="form__row">' +
                        '  <div class="form__col">' +
                        '    <label class="form__label"><strong>' +
                        that.translate('email_label') +
                        '</strong></label>' +
                        '      <input class="form__input notification__email" type="text" value="' +
                        result.data.email +
                        '">' +
                        '  </div>' +
                        '</div>'
                    );
                    //ADRES E-MAIL
                    popup.onSave = function() {
                        that.zapiszDaneDoPowiadomienia(termIksorisId, result.data.kontrahent_id);
                    };
                    popup.showPopup();
                } else {
                    let popup = new Popup(result.message || 'Wystąpił błąd w trakcie sprawdzania danych użytkownika');
                    popup.showPopup();
                }
            },
            error: function(xhr, status, error) {
                let popup = new Popup('Wystąpił błąd w trakcie sprawdzania danych użytkownika');
                popup.showPopup();
                console.error(status);
                console.error(error);
            }
        });
    }

    zapiszDaneDoPowiadomienia(termIksorisId, kontrahent_id) {
        const that = this;
        $.ajax({
            url: '/rezerwacja/termin.html',
            method: 'get',
            data: {
                json: true,
                ajax_action: 'zapisz_dane_do_powiadomienia',
                termin_iksoris_id: termIksorisId,
                email: $('.notification__email').val(),
                kontrahent_id: kontrahent_id
            },
            success: function(result) {
                if (result && result.status === 'complete') {
                    setTimeout(function() {
                        let popup = new Popup(
                            '<div class="form__section-header"><strong>POWIADOM O DOSTĘPNOŚCI BILETÓW</strong></div>' +
                            '<div class="fr-popup__text">Twój mail dodano do bazy dostępności biletów na spektakl "' +
                            result.data.wydarzenie +
                            '".</div>'
                        );
                        popup.showPopup();
                    }, 500);
                } else {
                    setTimeout(function() {
                        let popup = new Popup(result.message || 'nie udało się zapisać danych');
                        popup.showPopup();
                    }, 500);
                }
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
            }
        });
    }

    // getCategories() {
    //     const that = this;
    //     $.ajax({
    //         url: '/rezerwacja/termin.html',
    //         method: 'get',
    //         data: {
    //             json: true,
    //             ajax_action: 'pobierz_kategorie_twon'
    //         },
    //         success: function(result) {
    //             if (result && result.status === 'complete') {
    //                 that.terminSetting.kategorieWydarzen = result.data;
    //
    //                 that.writeCategories(result.data);
    //             } else {
    //                 console.error(result);
    //             }
    //         },
    //         error: function(xhr, status, error) {
    //             console.error(status);
    //             console.error(error);
    //         }
    //     });
    // }

    // setTermParams() {
    //     const that = this;
    //     let selectedDates = [];
    //     let datetime;
    //     let dayno;
    //     let zaznaczoneDni = $('ul#events-days-list li.selected');
    //     if (zaznaczoneDni.length === 0) {
    //         that.terminSetting.dataOd = $('#events-days-list li:first-child time').attr('datetime');
    //         that.terminSetting.dataDo = $('#events-days-list li:last-child time').attr('datetime');
    //     } else {
    //         $.each(zaznaczoneDni, function(index, row) {
    //             dayno = parseInt($(row).data('day'));
    //             if (dayno < 10) {
    //                 dayno = '0' + dayno;
    //             }
    //             datetime =
    //                 that.terminSetting.wybranyRok +
    //                 '-' +
    //                 (that.terminSetting.wybranyMiesiac < 10 ? '0' + that.terminSetting.wybranyMiesiac : that.terminSetting.wybranyMiesiac) +
    //                 '-' +
    //                 dayno;
    //             selectedDates.push(datetime);
    //         });
    //     }
    //
    //     if (selectedDates.length > 0) {
    //         that.terminSetting.dataOd = selectedDates[0]; //+' 00:00:00';
    //         selectedDates.reverse();
    //         that.terminSetting.dataDo = selectedDates[0]; //+' 23:59:59';
    //     }
    //
    //     let selectedCategory = $('ul#events-category-list li.selected');
    //
    //     if ($(selectedCategory).length > 0) {
    //         let category_id = $(selectedCategory).data('category_id');
    //         this.terminSetting.kategoriaWydarzen = category_id;
    //     }
    // }

    getTerms(callback) {
        const that = this;
        //that.setTermParams();
        $('.js-main-map').addClass('main__map--preloader');

        $.ajax({
            url: '/rezerwacja/termin.html',
            method: 'get',
            data: {
                json: true,
                ajax_action: 'pobierz_terminy',
                data_od: that.terminSetting.dataOd,
                data_do: that.terminSetting.dataDo,
                id_kategorii: that.terminSetting.kategoriaWydarzen,
                pogrupujPoDacie: true
            },
            success: function(result) {
                //console.log(result.data);

                $('.js-main-map').removeClass('main__map--preloader');
                that.writeTerms(result.data);
                if (callback && typeof callback === 'function') {
                    setTimeout(callback, 500);
                    setTimeout(callback, 1500);
                    setTimeout(callback, 2000);
                }
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
            }
        });
    }

    getCategoryName(category_id) {
        const that = this;
        let categoryName = '';
        $.each(that.terminSetting.kategorieWydarzen, function(index, row) {
            if (parseInt(row.id) === parseInt(category_id)) {
                categoryName = row.nazwa;
            }
        });
        return categoryName;
    }

    getActiveCategoryName() {
        let categoryName = '';
        let selectedCategory = $('#events-category-list li.selected');
        if (selectedCategory.length > 0 && parseInt(selectedCategory.data('category_id')) > 0) {
            let categoryLink = $(selectedCategory).find('a');
            if ($(categoryLink).length === 1) {
                categoryName = categoryLink.html();
            }
        }
        return categoryName;
    }

    writeTerms(terms) {
        const that = this;
        let termsHtml = '';
        let daysOfTheWeek = ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota', 'niedziela'];
        if (that.terminSetting.jezykStrony === 'en') {
            daysOfTheWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
        }

        let msg = that.translate('brak_terminow_w_przedziale_dat');
        if (that.terminSetting.dataOd === that.terminSetting.dataDo) {
            msg = that.translate('brak_terminow_w_dniu');
        }

        if (that.getActiveCategoryName()) {
            msg += ' ' + that.translate('w_kategorii') + ' "' + that.getActiveCategoryName() + '"';
        }

        function getBadge(term) {
            let badges = [
                {
                    status: term.infoOdwolany,
                    info: that.translate('spektakl_odwolany')
                },
                {
                    status: term.infoPremiera,
                    info: that.translate('premiera')
                },
                {
                    status: term.infoZamkniety,
                    info: that.translate('zamkniety')
                }
            ];

            let badgesInfo = '';

            badges.forEach(function(element) {
                if (element.status) {
                    badgesInfo += `<span class="badge">${element.info}</span>`;
                }
            });

            return badgesInfo;
        }

        if (terms.length === 0) {
            $('#no-terms-info').html(`<div class="mt-5 p-5">${msg}</div>`);
        } else {
            $('#no-terms-info').html('');
            let categoryNames;
            let place;
            let termButton;
            let eventImage;
            let kategorieData;

            $.each(terms, function(dateIndex, termsOnDate) {
                let dateObj = new Date(dateIndex);
                let weekdayNumber = dateObj.getDay();
                let weekDay = daysOfTheWeek[weekdayNumber];
                let dateIndexSplit = dateIndex.split('-');
                let dayOfTheMonth = parseInt(dateIndexSplit[2]);

                //ta pętla jest potrzebna do uzyskania do uzyskania id kategorii w danym dniu
                kategorieData = '';
                $.each(termsOnDate, function(termIndex, term) {
                    if (term.kategorie_id.length > 0) {
                        for (let i = 0; i < term.kategorie_id.length; i++) {
                            kategorieData += 'data-category-' + term.kategorie_id[i] + ' ';
                        }
                    }
                });

                termsHtml +=
                    '<li class="data-multiple data-event data-day-' +
                    dayOfTheMonth +
                    ' ' +
                    kategorieData +
                    '" tabindex="-1">' +
                    '<time datetime="' +
                    dateIndex +
                    '">' +
                    '<span class="day">' +
                    dayOfTheMonth +
                    '</span>' +
                    '<span class="weekday">' +
                    weekDay +
                    '</span>' +
                    '</time>' +
                    '<ul>';

                $.each(termsOnDate, function(termIndex, term) {
                    //date = term.dataTerminu;

                    eventImage = '';
                    if (term.obrazki.length > 0) {
                        eventImage = term.obrazki[0];
                    } else {
                        eventImage = '/assets/images/noimage.png';
                    }

                    categoryNames = [];
                    $.each(term.kategorie_id, function(i, category_id) {
                        categoryNames.push('<span class="category">' + that.getCategoryName(parseInt(category_id)) + '</span>');
                    });

                    place = term.infoMiejsce;
                    if (term.infoMiejsceLink != '#') {
                        place = '<a href="' + term.infoMiejsceLink + '">' + term.infoMiejsce + '</a>';
                    }
                    termButton = '';
                    if (term.terminWprzeszlosci) {
                        termButton = '<span>' + translates.termin_niedostepny + '</span>';
                    } else if (term.idTerminuIksoris) {
                        //term.idTerminuIksoris

                        if (term.wolneMiejsca === 0) {
                            termButton =
                                '<span>' +
                                that.translate('brak_miejsc') +
                                '</span><br />' +
                                '<a class="btn btn--large btn--brown powiadom-btn" href=""  data-id_terminu_twon="' +
                                term.id +
                                '" data-id_terminu_iksoris="' +
                                term.idTerminuIksoris +
                                '">' +
                                translates.powiadom_o_dostepnosci +
                                '<span class="visuallyhidden"></span></a>';
                        } else {
                            if (term.sprzedazOd.status) {
                                termButton = `<span class="btn btn--large btn--black" style="font-size: 11px; padding-left: 26px; padding-right: 26px;">${term.sprzedazOd.info}</span>`;
                            } else {
                                termButton =
                                    '<a class="btn btn--large btn--brown" href="' +
                                    term.terminUrl +
                                    '">' +
                                    that.translate('kup_bilet') +
                                    '<span class="visuallyhidden">' +
                                    term.opis +
                                    '</span></a>';
                            }
                        }
                    } else if (term.etykietaPrzycisku.length > 0) {
                        termButton = '<span>' + term.etykietaPrzycisku + '</span>';
                    } else {
                        termButton = '<span>' + translates.termin_niedostepny + '</span>';
                        //+'<a class="btn btn--large btn--brown powiadom-btn" href="" data-id_terminu_twon="'+term.id+'" data-id_terminu_iksoris="'+term.idTerminuIksoris+'">'+that.translate("powiadom")+'<span class="visuallyhidden"></span></a>';
                    }

                    termsHtml += `
                        <li class="data-event data-day-1 data-category-7" tabindex="-1">
                            <div class="event-img">
                                <div class="lazy-loading" data-target="lazy-loading">
                                    <a href="${term.urlWydarzenia}" tabindex="-1"><img class="lazy-loading__img" data-lazy-loading-src="${eventImage}" alt="${
                        term.opis
                    }"></a>
                                </div>
                            </div>
                            <div class="event">
                                <h3><a href="${term.urlWydarzenia}">${term.tytul}</a> ${getBadge(term)}</h3>
                                <p>
                                    <span class="hour">${term.godzinaTerminu}</span> /
                                    ${categoryNames.join(', ')} /
                                    <span class="hall">${place}</span>
                                </p>
                                <h4>${term.autor}</h4>
                                <p class="teaser">${term.opis}</p>
                          </div>
                          <div class="price ${term.sprzedazOd.status ? 'w-auto' : ''}">${termButton}</div>
                        </li>`;
                });

                termsHtml += '</ul>' + '</li>';
            });
        }
        $('#events-list').html(termsHtml);
        that.getActiveCategoryName();
        that.events();
    }

    // writeCategories(categories) {
    //     const that = this;
    //     let kategorieHtml =
    //         '<li class="data-category-all data-category-0 selected" data-category_id="0"><a href="#">' + that.translate('wszystkie') + '</a></li>';
    //     $.each(categories, function(index, row) {
    //         //kategorieHtml += '<li class="data-category-all data-category-'+row.id+' data-category_id="'+row.id+'"><a href="#">'+row.nazwa+'</a></li>';
    //         kategorieHtml += '<li class="data-category' + row.id + '" data-category_id="' + row.id + '"><a href="#">' + row.nazwa + '</a></li>';
    //     });
    //     $('ul#events-category-list').html(kategorieHtml);
    //     //that.getTerms();
    //     that.events();
    // }

    setInitialMonth() {
        let that = this;
        // let slectedMonthOnList = $('.category-list-months li.selected a');
        // console.log(slectedMonthOnList);
        //
        // if ($(slectedMonthOnList).length === 1) {
        //     let monthData = $(slectedMonthOnList).data();
        //     console.log(monthData);
        //     that.terminSetting.wybranyRok = monthData.rok;
        //     that.terminSetting.wybranyMiesiac = monthData.miesiac;
        //     that.terminSetting.liczbaDniWMiesiacu = monthData.dniwmiesiacu;
        //     that.terminSetting.dataOd = monthData.rok + '-' + (monthData.miesiac < 10 ? '0' + monthData.miesiac : monthData.miesiac) + '-01 00:00:00';
        //     that.terminSetting.dataDo =
        //         monthData.rok + '-' + (monthData.miesiac < 10 ? '0' + monthData.miesiac : monthData.miesiac) + '-' + monthData.dniwmiesiacu + ' 23:59:59';
        // } else {
        //     console.error('Brak wybranego miesiąca na kalendarzu .category-list-months li.selected');
        // }
        let monthDetails = that.getMonthDetails(yearToSelect, monthToSelect);
        //console.log(monthDetails);
        that.terminSetting.wybranyRok = yearToSelect;
        that.terminSetting.wybranyMiesiac = monthToSelect;
        that.terminSetting.liczbaDniWMiesiacu = monthDetails.daysInMth;
        that.terminSetting.dataOd = monthDetails.startDate;
        that.terminSetting.dataDo = monthDetails.endDate;
        $('.category-list-months li.selected').removeClass('selected');
        let mthBlock = $('.category-list-months li a[data-miesiac="' + monthToSelect + '"][data-rok="' + yearToSelect + '"]');
        //$('.category-list-months li a[data-miesiac="' + monthToSelect + '"][data-rok="' + yearToSelect + '"]').click();
        if (mthBlock.length > 0) {
            mthBlock.parent().addClass('selected');
        }

        if($('.category-list-months > li.selected').length === 0) {
            //console.log('selected', $($('.category-list-months > li')[0]).length);
            $($('.category-list-months > li')[0]).addClass('selected');

            let monthData = $('.category-list-months > li.selected > a').data();
            let monthDetails = that.getMonthDetails(monthData.rok, monthData.miesiac);
            that.terminSetting.dataOd = monthDetails.startDate;
            that.terminSetting.dataDo = monthDetails.endDate;
            that.writeDaysOfTheMonth();
        }

    }

    getMonthDetails(year, month) {
        let that = this;
        // Sprawdzenie poprawności danych wejściowych
        if (typeof year !== 'number' || typeof month !== 'number' || month < 1 || month > 12) {
            throw new Error('Invalid input. Year must be a number, and month must be a number between 1 and 12.');
        }

        // Data rozpoczęcia miesiąca
        const startDate = new Date(year, month - 1, 1, 0, 0, 0);

        // Data zakończenia miesiąca
        const endDate = new Date(year, month, 0, 23, 59, 59);

        // Liczba dni w miesiącu
        const daysInMonth = endDate.getDate();

        return {
            startDate: that.formatDate(startDate),
            endDate: that.formatDate(endDate),
            daysInMth: daysInMonth
        };
    }

    // Funkcja pomocnicza do formatowania daty
    formatDate(date) {
        const pad = (num) => String(num).padStart(2, '0');
        //return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    }

    /*
    po wybraniu określonego miesiąca i roku, numer miesiąca i rok są zapisywane w sesji.
    funkcja poniżej zaznacza zapamiętany miesiąc
    * */
    //setMonthFromSession() {
    // let numerMiesiacaSesja = $('#ostatnio_wybrany_miesiac').val();
    // let rokSesja = $('#ostatnio_wybrany_rok').val();
    // console.log(numerMiesiacaSesja, rokSesja);
    // $('.category-list-months li a[data-miesiac="' + numerMiesiacaSesja + '"][data-rok="' + rokSesja + '"]').click();
    // if (yearToSelect > 0 && monthToSelect > 0) {
    //     $('.category-list-months li a[data-miesiac="' + monthToSelect + '"][data-rok="' + yearToSelect + '"]').click();
    // }
    //}

    writeDaysOfTheMonth() {
        const that = this;
        let dniWMiesiacu = that.terminSetting.liczbaDniWMiesiacu;
        let dniHtml = '';
        let datetime;
        let d;
        let n;
        let weekday = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

        //let klasyDni = [];
        let klasyDniaArr;
        that.terminSetting.klasyDni = [];
        for (let i = 1; i <= dniWMiesiacu; i++) {
            klasyDniaArr = [];
            datetime =
                that.terminSetting.wybranyRok +
                '-' +
                (that.terminSetting.wybranyMiesiac < 10 ? '0' + that.terminSetting.wybranyMiesiac : that.terminSetting.wybranyMiesiac) +
                '-' +
                (i < 10 ? '0' + i : i);
            d = new Date(datetime);
            n = weekday[d.getDay()];

            klasyDniaArr.push(n);
            if (i === 1) klasyDniaArr.push('first');
            klasyDniaArr.push('selected');
            if (i === dniWMiesiacu) klasyDniaArr.push('last');
            that.terminSetting.klasyDni.push(klasyDniaArr);

            dniHtml +=
                '<li class="' +
                '" data-day="' +
                i +
                '">' +
                '<span class="drag drag-left"></span>' +
                '<span class="drag drag-left"></span>' +
                '<span class="drag drag-left"></span>' +
                '<span class="drag drag-left"></span>' +
                '<a href="https://teatrwielki.pl/#" tabindex="-1">' +
                '<time datetime="' +
                datetime +
                '">' +
                i +
                '</time>' +
                '</a>' +
                '<span class="drag drag-right"></span>' +
                '<span class="drag drag-right"></span>' +
                '<span class="drag drag-right"></span>' +
                '<span class="drag drag-right"></span>' +
                '</li>';
        }

        $('#events-days-list').html(dniHtml);

        let terminLoadFunction = function() {
            if ($('#events-days-list li.first').length === 0 && $('#events-days-list li.last').length === 0) {
                $.each(that.terminSetting.klasyDni, function(index, klasy) {
                    $($('#events-days-list li')[index]).addClass(klasy.join(' '));
                });
            }
        };


        that.getTerms(terminLoadFunction);
        that.events();
    }
}

export default Termin;
